/**
 * "Today" for the signed-in user (their profile time zone), not the browser's clock.
 * The server stamps dates with `dateInZone(now, user.timeZone)`; the client must agree,
 * or a snooze made at 01:00 Sofia from a UTC browser lands a day early (seen on CI 2026-10-31).
 */
let timeZone: string | null = null;

export function setTimeZone(tz: string | null): void {
  timeZone = tz;
}

export function todayIso(): string {
  try {
    if (timeZone) return new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
  } catch {
    /* unknown zone: fall through */
  }
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
